module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAcCAYAAABVo158AAABU0lEQVQ4T63UMU/CQBTA8f8DYzBa2Iybm4MjsyQaJ3FwMawmJn4FmZR2MBq/g9EPYIybk2LiaNh1IzowyFLKABp4pkVMW0B6ibf13f3a6917T7RiHYrjnZNwiNrZPqIHUvEukhgfKNCDfkns9s00NASAdpHUtlTc+79QCATLPFJsynHreRKKA39dE7QgtvcyDvmgDizHJt/RzzVxOm9xJGpbKyBPwGJs8pVuvyCn7Y9wXPwHtXN50CqQjSChRmZ2Q8pNbxgPwAAtrIPcgWSiX5JHcLfEpuPHf0GAHGsHlWtgJoZuWXV3pUQvAn7QHiqX8ZcBV9it/REw2J51BlIeOVbV8gQwvwTpxggQbfwXMNiSOlbynzY61okXJ1JF3WLk4vQkl+drTGpAjblYahgnnzrZOmqU3kFNh8fUAgoDkxLVLulUUY7chyRNwKjNGDYyw1b5DUUetAWMMztEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/icon_sj_orange_v2.png
// module id = 257
// module chunks = 1